<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close"></div>
        <div class="loadingIcon" v-if="loading"></div>
        <div class="tree"></div>
        <div class="plantNav nl" v-on:click="prevPot"
          v-if="potIdx > 1"></div>
        <div class="plantNav nr" v-on:click="nextPot"
          v-if="potIdx < 4"></div>
        <div class="plant" :class="accBot">
          <div class="charImg"></div>
          <div class="potItem pot1"></div>
          <div class="potItem pot2"
            :class="{locked: point < 100}">
            <div class="lock">
              <img src="../assets/locked.png">
              Terbuka di<br />100pt
            </div>
          </div>
          <div class="potItem pot3"
            :class="{locked: point < 400}">
            <div class="lock">
              <img src="../assets/locked.png">
              Terbuka di<br />400pt
            </div>
          </div>
          <div class="potItem pot4"
            :class="{locked: point < 600}">
            <div class="lock">
              <img src="../assets/locked.png">
              Terbuka di<br />600pt
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      point: 0,
      potIdx: 0,
      accBot: 'pot1',
      loading: false,
    };
  },
  methods: {
    open(d, next) {
      this.loading = false;
      this.accBot = this.$session.get('tufi2_acc_bot') || 'pot1';
      this.potIdx = parseInt(this.accBot.replace('pot', ''), 10);
      this.point = this.$session.get('tufi2_point') || 0;
      this.next = next;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, this.accBot);
    },
    prevPot() {
      if (this.potIdx === 1) return;
      this.potIdx -= 1;
      this.accBot = `pot${this.potIdx}`;
      this.saveChanges();
    },
    nextPot() {
      if (this.potIdx === 4) return;
      this.potIdx += 1;
      this.accBot = `pot${this.potIdx}`;
      this.saveChanges();
    },
    saveChanges() {
      if (this.accBot === 'pot2' && this.point < 100) return;
      if (this.accBot === 'pot3' && this.point < 400) return;
      if (this.accBot === 'pot4' && this.point < 600) return;
      this.$session.set('tufi2_acc_bot', this.accBot);
      this.loading = true;
      this.$http.post(this.$config.uri('user/set/acc'), {
        accBot: this.accBot,
      }).then((r) => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      background-color: #e6e1c1;
      z-index: 2;
      padding: 20px 20px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 640px;
      background-image: url(../assets/modal-bg2.jpg);
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      text-align: center;
      @media (max-width: 740px) {
        width: auto;
        left: 10px; right: 10px;
      }
      .tree{
        position: absolute;
        left: 0; right: -10px; bottom: 0; top: 0;
        background-image: url(../assets/FG-Kanan.svg);
        background-size: auto 120px;
        background-position: right bottom;
        background-repeat: no-repeat;
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        z-index: 7;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      .loadingIcon{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 46px; top: 10px;
        background-image: url(../assets/loading.svg);
        background-size: 24px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        z-index: 7;
      }
      .plantNav{
        position: absolute;
        top: 0; bottom: 0;
        width: calc(50% - 100px);
        cursor: pointer;
        z-index: 4;
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .2;
        transition: all .3s ease;
        @media (max-width: 680px) {
          width: calc(50% - 80px);
        }
        &:hover{
          opacity: .56;
          transition: all .3s ease;
        }
        &.nl{
          left: 0;
          background-image: url(../assets/left-arrow.png);
        }
        &.nr{
          right: 0;
          background-image: url(../assets/right-arrow.png);
        }
      }
      .plant{
        height: 400px;
        position: relative;
        z-index: 3;
        @media (max-width: 680px) {
          height: 340px;
        }
        .charImg{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-image: url(../assets/char/Lv5.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
        }
        .potItem{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          transition: all .3s ease;
          &:before{
            position: absolute;
            content: "";
            transition: all .3s ease;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            left: 0; top: 0; right: 0; bottom: 0;
          }
          &.pot1{
            &:before{
              background-image: url(../assets/char/Pot1.png);
            }
          }
          &.pot2{
            &:before{
              background-image: url(../assets/char/Pot2.png);
            }
          }
          &.pot3{
            &:before{
              background-image: url(../assets/char/Pot3.png);
            }
          }
          &.pot4{
            &:before{
              background-image: url(../assets/char/Pot4.png);
            }
          }
          .lock{
            position: absolute;
            left: 0; right: 0; bottom: 44px;
            text-align: center;
            color: #fff;
            display: none;
            font-size: 12px;
            z-index: 3;
            img{
              display: block;
              margin: 0 auto 6px;
              height: 26px;
            }
          }
          &.locked{
            &:before{
              filter: brightness(0);
            }
            .lock{
              display: block;
            }
          }
        }
        &.pot1{
          .potItem.pot2{
            transform: translateX(200px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot3{
            transform: translateX(400px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot4{
            transform: translateX(600px) scale(.9);
            filter: grayscale(1);
          }
        }
        &.pot2{
          .potItem.pot1{
            transform: translateX(-200px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot3{
            transform: translateX(200px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot4{
            transform: translateX(400px) scale(.9);
            filter: grayscale(1);
          }
        }
        &.pot3{
          .potItem.pot1{
            transform: translateX(-400px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot2{
            transform: translateX(-200px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot4{
            transform: translateX(200px) scale(.9);
            filter: grayscale(1);
          }
        }
        &.pot4{
          .potItem.pot1{
            transform: translateX(-600px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot2{
            transform: translateX(-400px) scale(.9);
            filter: grayscale(1);
          }
          .potItem.pot3{
            transform: translateX(-200px) scale(.9);
            filter: grayscale(1);
          }
        }
      }
    }
  }
</style>
